import React from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import AssetIcon from './Icon';
import ActionBarItemWrapper from '../../ActionBar/_partials/items/ActionBarItemWrapper';
import classnames from 'classnames';
// eslint-disable-next-line @wix/da/scss-same-filename-as-module
import s from './Button.scss';
export var FunigbleButton = function (props) {
    var deviation = props.deviation, openManageModal = props.openManageModal, _a = props.deviation.extended, _b = _a === void 0 ? {} : _a, digitalAssetFull = _b.digitalAsset;
    var digitalAsset = deviation.digitalAsset;
    var digital_assets = useFlag('digital_assets');
    if (!digital_assets) {
        return null;
    }
    // Bail no asset
    if (!digitalAsset || !digitalAssetFull) {
        return null;
    }
    var editionStats = digitalAsset.editionStats;
    var offers = digitalAssetFull.offers;
    var hasOffer = false, madeOffer = false;
    if (offers) {
        hasOffer = !!offers.hasOffer;
        madeOffer = !!offers.madeOffer;
    }
    // Handle owner state
    if (hasOffer) {
        return (React.createElement(ActionBarItemWrapper, { tooltip: hasOffer ? 'You have an one or more offers!' : '', className: classnames(hasOffer && s['red-dot']) },
            React.createElement(GhostButton, { size: 'medium', variant: 'edit-purple', icon: AssetIcon, onClick: function () {
                    openManageModal && openManageModal(deviation);
                } }, "Manage Collectible")));
    }
    // This user made an offer
    if (madeOffer) {
        return (React.createElement(ActionBarItemWrapper, { tooltip: 'You made one or more offers!' },
            React.createElement(GhostButton, { size: 'medium', variant: 'edit-purple', icon: AssetIcon, onClick: function () {
                    openManageModal && openManageModal(deviation);
                } }, "Manage Offer(s)")));
    }
    // There are editions...
    return (React.createElement(ActionBarItemWrapper, { tooltip: "Trade Collectibles of this deviation!" },
        React.createElement(GhostButton, { size: 'medium', variant: 'main', icon: AssetIcon, onClick: function () {
                openManageModal && openManageModal(deviation);
            } }, (editionStats === null || editionStats === void 0 ? void 0 : editionStats.lowDollarPrice) && editionStats.lowDollarPrice !== '0.00'
            ? "Trade from $".concat(editionStats === null || editionStats === void 0 ? void 0 : editionStats.lowDollarPrice)
            : "Trade Collectibles")));
};
FunigbleButton.displayName = 'DasFungibleButton';
export default FunigbleButton;
//# sourceMappingURL=FungibleButton.js.map